<span class="max-w-sm flex-1">
  {{ 'E-mail' | translate }}
</span>
<span class="max-w-sm flex-1">
  {{ 'Phone' | translate }}
</span>
<span class="max-w-sm flex-1">
  {{ 'Mobile' | translate }}
</span>
